import { render, staticRenderFns } from "./SideCart.vue?vue&type=template&id=a3e957cc&scoped=true"
import script from "./SideCart.ts?vue&type=script&lang=ts&external"
export * from "./SideCart.ts?vue&type=script&lang=ts&external"
import style0 from "./SideCart.scss?vue&type=style&index=0&id=a3e957cc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e957cc",
  null
  
)

export default component.exports